import { useCallback, useState } from "react";
import { useSnackbar } from "notistack";
import {
  fetchDocumentTypes,
  createDocumentType,
  updateDocumentType,
  deleteDocumentType,
  reorderDocumentTypes,
} from "@accredo/fe-shared/services/documentTypeService.js";

export function useDocumentTypeActions() {
  const { enqueueSnackbar } = useSnackbar();
  const [documentTypes, setDocumentTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false);

  const load = useCallback(() => {
    setIsLoading(true);
    return fetchDocumentTypes()
      .then((res) => {
        setDocumentTypes(res.data ?? []);
        setHasLoaded(true);
      })
      .catch(() =>
        enqueueSnackbar("Dokumenttypen konnten nicht geladen werden", {
          variant: "error",
        })
      )
      .finally(() => setIsLoading(false));
  }, [enqueueSnackbar]);

  const create = async (payload) => {
    const result = await createDocumentType(payload);
    await load();
    return result;
  };

  const update = async (document_type_id, payload) => {
    const result = await updateDocumentType(document_type_id, payload);
    await load();
    return result;
  };

  const remove = async (document_type_id) => {
    await deleteDocumentType(document_type_id);
    await load();
  };

  const reorder = async (ids) => {
    const result = await reorderDocumentTypes(ids);
    await load();
    return result;
  };

  return {
    documentTypes,
    isLoading,
    hasLoaded,
    load,
    create,
    update,
    remove,
    reorder,
  };
}
